export function start(state, { chatId }) {
    return state
        .setIn([ 'items', chatId, 'isUserTyping' ], true);
}

export function stop(state, { chatId }) {
    return state
        .setIn([ 'items', chatId, 'isUserTyping' ], false);
}
